import { Container, Box } from "@mui/material"
import { makeStyles } from "makeStyles"
import Graphic from "svg/seriesPage/verankerung-graphic.svg"

const useStyles = makeStyles()(() => ({
	graphicSize: {
		width: "140%",
		"@media only screen and (max-width: 600px)": {
			width: "100%",
		},
	},
	graphicPosition: {
		position: "absolute",
		top: "30%",
		right: "0%",
		transform: "translate(-50%, -50%)",
		opacity: 0.4,
		"@media only screen and (max-width: 960px)": {
			right: -150,
		},
	},
}))

const BurglaryProtection = ({ anchoringContent }: Props) => {
	const { classes } = useStyles()

	return (
		<Box mt={18} style={{ zIndex: 1 }}>
			<Container style={{ position: "relative", minHeight: 300 }}>
				<div className={classes.graphicPosition}>
					<Graphic className={classes.graphicSize} />
				</div>

				<Box py={5} px={2} style={{ maxWidth: 800, position: "relative" }}>
					<div
						dangerouslySetInnerHTML={{
							__html: anchoringContent,
						}}
						style={{ marginTop: 40, lineHeight: 1.4 }}
					/>
				</Box>
			</Container>
		</Box>
	)
}

interface Props {
	anchoringContent: string
}

export default BurglaryProtection
